import type { Locale } from "@/lib/i18n";

interface IntentShiftCalloutProps {
  locale: Locale;
}

export function IntentShiftCallout({ locale }: IntentShiftCalloutProps) {
  const copy =
    locale === "es"
      ? "Si ya estás haciendo esto y no ves resultados, el problema suele ser estructural, no táctico. Ahí es donde entramos nosotros."
      : "If you're already doing this and not seeing results, the issue is usually structural, not tactical. That's where we come in.";

  return (
    <aside
      className="institutional-intent-note resource-decision-note not-prose my-12 rounded-2xl border border-[var(--line-neutral)] bg-[var(--surface-methodology)] px-6 py-5"
      data-component="resource-decision-note"
      data-surface="light"
    >
      <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
        {locale === "es" ? "Nota de decisión" : "Decision note"}
      </p>
      <p className="mt-3 text-base font-medium leading-relaxed text-foreground sm:text-lg">{copy}</p>
    </aside>
  );
}
